// userService.js - Service Layer for User Management API Calls

const getApiBase = () => {
  const rawBase = process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";
  return rawBase.replace(/\/$/, "");
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
};

export const userService = {
  // Fetch user profile details
  async getUserById(userId) {
    const base = getApiBase();
    const headers = getAuthHeaders();
    const res = await fetch(`${base}/api/users/${userId}`, { headers });
    if (!res.ok) throw new Error("Failed to fetch user data");
    return await res.json();
  },

  // Fetch bookings for specific user
  async getUserBookings(userId) {
    const base = getApiBase();
    const headers = getAuthHeaders();
    const res = await fetch(`${base}/api/bookings/user/${userId}`, { headers });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : data.bookings || [];
  },

  // Fetch subscription details for user
  async getUserSubscription(userId) {
    const base = getApiBase();
    const headers = getAuthHeaders();
    const res = await fetch(`${base}/api/subscriptions/user/${userId}`, { headers });
    if (!res.ok) return null;
    return await res.json();
  },

  // Fetch analytics metrics for user
  async getUserAnalytics(userId) {
    const base = getApiBase();
    const headers = getAuthHeaders();
    const res = await fetch(`${base}/api/users/${userId}/analytics`, { headers });
    if (!res.ok) return null;
    return await res.json();
  },

  // Update user profile status / details
  async updateUserStatus(userId, statusData) {
    const base = getApiBase();
    const headers = getAuthHeaders();
    const res = await fetch(`${base}/api/users/${userId}/status`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(statusData),
    });
    if (!res.ok) throw new Error("Failed to update user status");
    return await res.json();
  },

  // Delete user record
  async deleteUser(userId) {
    const base = getApiBase();
    const headers = getAuthHeaders();
    const res = await fetch(`${base}/api/users/${userId}`, {
      method: "DELETE",
      headers,
    });
    if (!res.ok) throw new Error("Failed to delete user");
    return await res.json();
  },
};
